import TitleHeader from '../components/TitleHeader';
import { Spinner } from 'mdbreact';
import React from 'react';
import PropTypes from 'prop-types';
import { newReleaseGrey } from '../../../assets/images/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import ProductBox from '../../BoxProduct/components/ProducBox';
import SearchContainer from '../Delivery/components/SearchContainer';

const Novelty = ({
    products,
    hasMore,
    isLoading,
    loadMore,
    title,
    titleValues,
    openProductDetails,
    toggleProductFavorite,
}) => {
    return (
        <div className="row">
            <div className="col">
                <TitleHeader
                    icon={newReleaseGrey}
                    title={title}
                    values={titleValues}
                    className="left-align-header"
                >
                    <SearchContainer isWithIcon={true} type="novelty" />
                </TitleHeader>

                {isLoading && products.length === 0 && (
                    <div className="d-flex justify-content-center my-4">
                        <Spinner className="brand-color" />
                    </div>
                )}

                <InfiniteScroll
                    className="box-products"
                    hasMore={!isLoading && hasMore}
                    next={loadMore}
                    dataLength={products.length}
                    loader={
                        <div className="flex-center">
                            {' '}
                            <Spinner className="brand-color" />
                        </div>
                    }
                >
                    {products.map((product, index) => {
                        return (
                            <ProductBox
                                index={index}
                                key={product.id}
                                product={product}
                                openProductDetails={openProductDetails}
                                toggleProductFavorite={toggleProductFavorite}
                                isNoveltyPage
                            />
                        );
                    })}
                </InfiniteScroll>
            </div>
        </div>
    );
};

Novelty.propTypes = {
    hasMore: PropTypes.bool,
    isLoading: PropTypes.any,
    loadMore: PropTypes.func,
    products: PropTypes.array,
    title: PropTypes.string,
    titleValues: PropTypes.object,
};

Novelty.defaultProps = {
    title: 'menu.novelty',
    titleValues: {},
};

export default Novelty;
